import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { TranslateModule } from "@ngx-translate/core";

import { BfxOrderBlotterAuditComponent } from "./bfx-order-blotter-audit.component";
import { OrderActionPipe } from "./pipes/bfx-order-action.pipe";
import { JSONMessagePipe } from "./pipes/bfx-json-message.pipe";
import { BfxDatePipe } from "./pipes/bfx-date.pipe";
import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BfxOrderBlotterAuditService } from "./bfx-order-blotter-audit.service";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AgGridModule } from "@bfx/ag-grid-angular";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    BfxSharedModule,
    TranslateModule,
    CheckboxModule,
    FormsModule,
    NativeDesktopModule,
    PerfectScrollbarModule,
    FlexLayoutModule,
    AgGridModule.withComponents([]),
  ],
  providers: [
    BfxOrderBlotterAuditService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
  declarations: [BfxOrderBlotterAuditComponent, OrderActionPipe, JSONMessagePipe, BfxDatePipe],
  exports: [BfxOrderBlotterAuditComponent, OrderActionPipe, JSONMessagePipe, BfxDatePipe],
  bootstrap: [BfxOrderBlotterAuditComponent],
})
export class BfxOrderAuditModule {}
